/** Iter 632 — customer wizard · waiting-for-till card (JSX moved verbatim from EngageSessionPanel.jsx). */
import React from "react";
import WizardBar from "@/features/customerWizard/WizardBar";
import PhotoStep from "@/features/customerWizard/PhotoStep";

export default function WaitingCard({ w }) {
  const { photo, waiting, skipChosen, setPhoto, setSkipChosen, extraPhotos, setExtraPhotos } = w;
  return (
    <div>
      <WizardBar step={2} />
      {/* Iter-558 — the Photo step doubles as the waiting screen: the
          customer can snap their photo while staff start the sale. */}
      <div className="rounded-2xl bg-white border border-slate-200 shadow-card p-6" data-testid="engage-waiting-till">
        <PhotoStep
          photo={photo}
          waitingMsg={waiting}
          skipChosen={skipChosen}
          onPhoto={setPhoto}
          onSkip={() => setSkipChosen(true)}
          extraPhotos={extraPhotos}
          onAddExtra={(p) => setExtraPhotos((prev) => [...prev, p].slice(0, 3))}
        />
        <p className="mt-3 text-center text-[11px] text-slate-400">This page checks again every few seconds — keep it open.</p>
      </div>
    </div>
  );
}
